// 豆趣拼豆 · 我的作品页
import { listWorks, deleteWork, patchWork, exportBackup, importBackup, formatTime } from './works-store.js';

const $ = (id) => document.getElementById(id);
const grid = $('worksGrid'), empty = $('worksEmpty'), status = $('worksStatus');
const say = (s) => { status.textContent = s; if (s) setTimeout(() => { if (status.textContent === s) status.textContent = ''; }, 5000); };
const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const n = (v) => Number(v || 0).toLocaleString('zh-CN');
let works = [];

function progressOf(w) {
  if (!w.progress?.done) return null;
  const cells = w.project.grid.cells; let done = 0, total = 0;
  for (let i = 0; i < cells.length; i++) if (cells[i]) { total++; if (w.progress.done[i]) done++; }
  return total ? { done, total, pct: Math.floor((done / total) * 100) } : null;
}

async function render() {
  try { works = await listWorks(); } catch (e) { grid.removeAttribute('aria-busy'); empty.hidden = false; $('worksEmptyText').textContent = '这个浏览器暂时无法使用本地存储（可能处于无痕模式），作品无法保存。'; return; }
  grid.removeAttribute('aria-busy');
  empty.hidden = works.length > 0; $('exportBackup').disabled = !works.length;
  $('worksCount').textContent = works.length ? `共 ${works.length} 件` : '';
  grid.innerHTML = works.map((w) => {
    const p = progressOf(w);
    return `<article class="work-card" data-id="${esc(w.id)}">
  <a class="work-thumb" href="../app.html?work=${encodeURIComponent(w.id)}" aria-label="继续编辑「${esc(w.name)}」"><img src="${w.thumb}" alt="" width="${w.cols}" height="${w.rows}" loading="lazy" decoding="async"></a>
  <div class="work-body">
    <h2 class="work-name">${esc(w.name)}</h2>
    <p class="work-meta">${w.cols} × ${w.rows} 格 · ${w.colorCount} 色 · ${n(w.beads)} 颗</p>
    <p class="work-time">更新于 ${formatTime(w.updatedAt)}</p>
    ${p ? `<div class="work-progress" aria-label="已拼 ${p.pct}%"><i style="width:${p.pct}%"></i></div><p class="work-time">已拼 ${p.pct}% · 还剩 ${n(p.total - p.done)} 颗</p>` : ''}
    <div class="work-actions">
      <a class="btn brand" href="./bead.html?id=${encodeURIComponent(w.id)}">${p && p.done ? '继续拼豆' : '开始拼豆'}</a>
      <a class="btn secondary" href="../app.html?work=${encodeURIComponent(w.id)}">编辑</a>
      <button type="button" class="btn quiet" data-act="rename">重命名</button>
      <button type="button" class="btn quiet" data-act="delete">删除</button>
    </div>
  </div>
</article>`;
  }).join('');
}

let target = null;
grid.addEventListener('click', (e) => {
  const b = e.target.closest('button[data-act]'); if (!b) return;
  target = works.find((w) => w.id === b.closest('.work-card').dataset.id); if (!target) return;
  if (b.dataset.act === 'rename') { $('renameInput').value = target.name; $('renameDialog').showModal(); $('renameInput').select(); }
  else { $('deleteName').textContent = `「${target.name}」`; $('deleteDialog').showModal(); $('deleteCancel').focus(); }
});
$('renameForm').addEventListener('submit', async (e) => {
  e.preventDefault(); const name = $('renameInput').value.trim().slice(0, 80);
  if (!name || !target) { $('renameDialog').close(); return; }
  await patchWork(target.id, { name, project: { ...target.project, title: name }, updatedAt: Date.now() });
  $('renameDialog').close(); say(`已重命名为「${name}」`); render();
});
$('renameCancel').addEventListener('click', () => $('renameDialog').close());
$('deleteCancel').addEventListener('click', () => $('deleteDialog').close());
$('deleteConfirm').addEventListener('click', async () => {
  if (!target) return; await deleteWork(target.id); $('deleteDialog').close(); say(`已删除「${target.name}」`); target = null; render();
});
$('exportBackup').addEventListener('click', async () => {
  const blob = await exportBackup(), a = document.createElement('a'), d = new Date();
  a.href = URL.createObjectURL(blob); a.download = `豆趣拼豆-作品备份-${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}.json`;
  document.body.append(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(a.href), 4000);
  say(`已导出 ${works.length} 件作品的备份`);
});
$('importBackup').addEventListener('change', async (e) => {
  const f = e.target.files[0]; e.target.value = ''; if (!f) return;
  try { const r = await importBackup(await f.text()); say(`导入完成：新增 ${r.added} 件${r.updated ? `，更新 ${r.updated} 件` : ''}${r.skipped ? `，${r.skipped} 件已是最新` : ''}`); render(); }
  catch (_) { say('这个文件不是豆趣拼豆的作品备份，换一个试试。'); }
});
render();
